import React from 'react';
import {navigate} from 'gatsby';
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer';

export const getCategoryAndSubCategory = (str: any, replaceHypenWithSpace = true) => {
  const parts = str ? str.toLowerCase().split(':') : [];
  const category = parts[0];
  let subCategory = parts[1];

  if (replaceHypenWithSpace)
    subCategory = subCategory ? subCategory.replace(/-/g, ' ') : '';

  return [category, subCategory];
};

export const parseStringToHTML = (str: string) => {
  if (str.includes('#LB')) {
    const stringParts = str.split('#LB');

    return stringParts.map((item, index) => {
      if (index === stringParts.length - 1)
        return item.trim();

      return (
        <>
          {item.trim()}
          <br />
        </>
      );
    });
  }

  return str;
};

export const getPreviousPageLink = (defaultLink: string) => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && document.referrer) {
    const url = new URL(document.referrer);
    const target = url.href.replace(url.origin, '');

    return target;
  }

  return defaultLink;
};

export const goBack = (defaultLink: string) => {
  if (![typeof window, typeof document, typeof history].includes('undefined') && window.previousPath) {
    history.go(-1);

    return;
  }

  navigate(defaultLink);
};

// Helps filtering out null or undefined values
export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

const NUMBER_OF_WORDS_READ_PER_MIN = 200;

export const calculateReadingTime = (content: any) => {
  const articleString = documentToPlainTextString(content?.json);
  const numberOfWords = articleString.split(' ').length;

  return Math.round(numberOfWords / NUMBER_OF_WORDS_READ_PER_MIN);
};
